// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/components/EventCalendar/calendar.module.css
// module id = 2278
// module chunks = 0